<div
  class="flex flex-col lg:flex-row md:flex-col items-start max-w-screen-xl mx-auto p-2 lg:p-5 sm:p-6 md:p-3 m-2 rounded-lg"
>
  <!-- Button to open filters modal on mobile/tablet -->
  <div class="lg:hidden">
    <button
      (click)="openFiltersModal()"
      *ngIf="allProduct.length != 0"
      class="bg-[#7B68EE] py-1 px-2 m-2 text-white font-medium rounded-md"
    >
      Show Filters
    </button>
  </div>

  <!-- Filters modal for mobile/tablet -->
  <app-filters-modal #filtersModal (close)="onFiltersModalClose()">
    <aside
      class="w-full lg:w-1/5 py-4 md:block overflow-hidden"
      *ngIf="allProduct.length != 0"
    >
      <div class="top-12 flex flex-col p-3 border shadow-lg rounded-xl">
        <div class="filters">
          <div class="flex justify-between">
            <h2 class="font-semibold text-lg lg:text-xl py-1 px-2 m-2">
              Filters
            </h2>
            <button
              (click)="resetFilters()"
              class="bg-[#7B68EE] py-1 px-2 m-2 text-white font-medium rounded-md"
            >
              Clear
            </button>
          </div>

          <!-- Brand Filter -->
          <div class="p-3">
            <label class="text-purple-700 font-bold">Brand</label><br />
          <div *ngFor="let brand of visibleBrands; let i = index">
  <input
    type="checkbox"
    [value]="brand"
    (change)="toggleBrand(brand); onFilterSelect()"
    [checked]="selectedBrands.has(brand)"
  />
  <label class="mx-2">{{ brand }}</label>
</div>

<!-- Show More / Show Less button -->
<div *ngIf="brands.length > 5">
  <button class="btn btn-link" (click)="toggleShowMore()">
    {{ showAllBrands ? 'Show Less' : 'Show More' }}
  </button>
</div>

          </div>

          <!-- Color Filter -->
          <div class="p-3">
            <label class="text-purple-700 font-bold">Color</label><br />
            <div *ngFor="let color of colors">
              <input
                type="checkbox"
                [value]="color"
                (change)="toggleColor(color); onFilterSelect()"
                [checked]="selectedColors.has(color)"
              />
              <label class="mx-2">{{ color }}</label>
            </div>
          </div>

          <!-- Price Filter -->
          <div class="p-3">
            <label class="text-purple-700 font-bold">Price</label><br />
            <div *ngFor="let range of priceRanges">
              <input
                type="checkbox"
                (change)="togglePriceRange(range); onFilterSelect()"
                [checked]="selectedPriceRanges.has(range)"
              />
              {{ range.label }}
            </div>
          </div>

          <!-- Discount Filter -->
          <div class="p-3">
            <label class="text-purple-700 font-bold">Discount</label><br />
            <div *ngFor="let discount of discounts">
              <input
                type="checkbox"
                [value]="discount"
                (change)="toggleDiscount(discount); onFilterSelect()"
                [checked]="selectedDiscounts.has(discount)"
              />
              <label class="mx-2">{{ discount }}</label>
            </div>
          </div>
        </div>
      </div>
    </aside>
  </app-filters-modal>

  <!-- Filters aside for desktop -->
  <aside
    class="w-full lg:w-1/5 md:hidden py-4 md:block overflow-hidden hidden lg:block"
    [ngClass]="{ 'fixed-aside': isSticky }"
    *ngIf="allProduct.length != 0 && !isMobileOrTablet"
  >
    <div class="top-12 flex flex-col p-3 border shadow-lg rounded-xl">
      <div class="filters">
        <div class="flex justify-between">
          <h2 class="font-semibold text-lg lg:text-xl py-1 px-2 m-2">
            Filters
          </h2>
          <button
            (click)="resetFilters()"
            class="bg-[#7B68EE] py-1 px-2 m-2 text-white font-medium rounded-md"
          >
            Clear
          </button>
        </div>

        <!-- Brand Filter -->
        <div class="p-3">
          <label class="text-purple-700 font-bold">Brand</label><br />
          <div *ngFor="let brand of brands; let i = index">
            <input
              type="checkbox"
              [value]="brand"
              (change)="toggleBrand(brand)"
              [checked]="selectedBrands.has(brand)"
            />
            <label class="mx-2">{{ brand }}</label>
          </div>
        </div>

        <!-- Color Filter -->
        <div class="p-3">
          <label class="text-purple-700 font-bold">Color</label><br />
          <div *ngFor="let color of colors">
            <input
              type="checkbox"
              [value]="color"
              (change)="toggleColor(color)"
              [checked]="selectedColors.has(color)"
            />
            <label class="mx-2">{{ color }}</label>
          </div>
        </div>

        <!-- Price Filter -->
        <div class="p-3">
          <label class="text-purple-700 font-bold">Price</label><br />
          <div *ngFor="let range of priceRanges">
            <input
              type="checkbox"
              (change)="togglePriceRange(range)"
              [checked]="selectedPriceRanges.has(range)"
            />
            {{ range.label }}
          </div>
        </div>

        <!-- Discount Filter -->
        <div class="p-3">
          <label class="text-purple-700 font-bold">Discount</label><br />
          <div *ngFor="let discount of discounts">
            <input
              type="checkbox"
              [value]="discount"
              (change)="toggleDiscount(discount)"
              [checked]="selectedDiscounts.has(discount)"
            />
            <label class="mx-2">{{ discount }}</label>
          </div>
        </div>
      </div>
    </div>
  </aside>

  <main class="w-full  w-4/4 py-1 min-h-screen" >
    <div
      class="flex justify-between items-center"
      *ngIf="allProduct.length > 0"
    >
      <h1 class="font-bold text-lg lg:text-xl my-4 mx-3">Product List</h1>
      <select
        (change)="onSortOrderChange($event)"
        class="bg-[#7B68EE] h-9 my-auto text-white rounded-md px-2"
      >
        <option value="" selected disabled hidden>Sort by Price</option>
        <option value="lowToHigh">Low to High</option>
        <option value="highToLow">High to Low</option>
      </select>
    </div>

    <div *ngIf="allProductFilter.length > 0 "
      class="grid grid-cols-2 xs:grid-cols-2 sm:grid-cols-2 md:grid-cols-3 ml-2 lg:grid-cols-4 gap-0 xs:gap-2"
    >
      <app-product
        *ngFor="let product of allProductFilter "
        [product]="product"
        (click)="productDetails(product)" 
      ></app-product>

  


       <!-- Loading Indicator -->
    <div *ngIf="isLoadingMore" class="w-full flex justify-center py-8">
      <div class="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-purple-700"></div>
  </div>

  

    </div>

    <h1 *ngIf="allProductFilter.length === 0 !! !isLoading" class="text-center font-normal text-lg">Product not found for <span class="font-semibold text-blue-500">{{searchTerm}}</span></h1>
   <p *ngIf="allProductFilter.length === 0 !! !isLoading" class="text-start ml-6 text-xl font-medium mt-5">Similar Product</p>
     <div *ngIf="allProductFilter.length === 0 !! !isLoading"
      class="grid grid-cols-2 xs:grid-cols-2 sm:grid-cols-2 md:grid-cols-3 ml-2 lg:grid-cols-4 gap-0 xs:gap-2"
   >
   
   <app-product
        *ngFor="let product of suggestProduct "
        [product]="product"
        (click)="productDetails(product)" 
      ></app-product>


       <!-- Loading Indicator -->
    <div *ngIf="isLoadingMore" class="w-full flex justify-center py-8">
      <div class="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-purple-700"></div>
  </div>

  

    </div>
<!-- End of Results Message -->
<div *ngIf="!hasMoreItems && allProduct.length > 0" class="w-full text-center py-6 text-gray-500">
  You've viewed all product!
</div>
  
    <!-- <div *ngIf="allProductFilter.length === 0  !!  !isLoading">
      <div
        class="no-file-found flex flex-col items-center justify-center py-8 w-full  lg:mt-14 px-4 mx-4 text-center dark:bg-gray-800 rounded-lg"
      >
        <svg
          class="w-12 h-12 dark:text-gray-400 text-gray-700"
          stroke="currentColor"
          fill="currentColor"
          stroke-width="0"
          viewBox="0 0 24 24"
          height="200px"
          width="200px"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g id="File_Off">
            <g>
              <path
                d="M4,3.308a.5.5,0,0,0-.7.71l.76.76v14.67a2.5,2.5,0,0,0,2.5,2.5H17.44a2.476,2.476,0,0,0,2.28-1.51l.28.28c.45.45,1.16-.26.7-.71Zm14.92,16.33a1.492,1.492,0,0,1-1.48,1.31H6.56a1.5,1.5,0,0,1-1.5-1.5V5.778Z"
              ></path>
              <path
                d="M13.38,3.088v2.92a2.5,2.5,0,0,0,2.5,2.5h3.07l-.01,6.7a.5.5,0,0,0,1,0V8.538a2.057,2.057,0,0,0-.75-1.47c-1.3-1.26-2.59-2.53-3.89-3.8a3.924,3.924,0,0,0-1.41-1.13,6.523,6.523,0,0,0-1.71-.06H6.81a.5.5,0,0,0,0,1Zm4.83,4.42H15.88a1.5,1.5,0,0,1-1.5-1.5V3.768Z"
              ></path>
            </g>
          </g>
        </svg>
        <h3 class="text-xl font-medium mt-4 text-gray-700 dark:text-gray-200">
          Product not found
        </h3>
        <p class="text-gray-500 dark:text-gray-400 mt-2"></p>
      </div>
      <div
      class="grid grid-cols-2 xs:grid-cols-2 sm:grid-cols-2 md:grid-cols-3 ml-2 lg:grid-cols-4 gap-0 xs:gap-2"
    >
  
      <app-product
        *ngFor="let product of suggestProduct"
        [product]="product"
        (click)="productDetails(product)" 
      ></app-product>

  

    </div>
    </div> -->
  </main>

  
</div>
